import React, { useState } from "react";
import apiService from "../../services/apiService";


export default function EditDealerBankModal({ dealer, onClose }) {
  const [bank, setBank] = useState({
    bank_account_name: dealer?.bank_details?.bank_account_name || "",
    bank_name: dealer?.bank_details?.bank_name || "",
    branch: dealer?.bank_details?.branch || "",
    ifsc_code: dealer?.bank_details?.ifsc_code || "",
    account_number: dealer?.bank_details?.account_number || "",
  });
  const [reAccountNumber, setReAccountNumber] = useState(dealer?.bank_details?.account_number || "");
  const [accountNumberError, setAccountNumberError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    // Convert all text input to uppercase (except account_number which is numeric)
    const upperValue = name === 'account_number' ? value : value.toUpperCase();
    setBank((prev) => ({ ...prev, [name]: upperValue }));
  };

  const handleSubmit = async () => {
    setAccountNumberError("");
    if (bank.account_number !== reAccountNumber) {
      setAccountNumberError("Account numbers do not match");
      return;
    }
    try {
      const response = await apiService.post("manuallyEditBankDetails", {
        dealer_uid: dealer.uid || dealer.id,
        bank_details: bank,
      });

      if (response.error) {
        alert("Error: " + response.message);
        return;
      }

      alert("Bank details updated successfully");
      onClose();
    } catch (error) {
      console.error("Error updating bank details:", error);
      alert("An unexpected error occurred.");
    }
  };

  const styles = {
    backdrop: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      background: "rgba(0,0,0,0.4)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 999,
    },
    modal: {
      width: "450px",
      background: "white",
      padding: "2rem",
      borderRadius: "12px",
      boxShadow: "0 4px 25px rgba(0,0,0,0.25)",
      position: "relative",
      fontFamily:
        '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    },
    closeBtn: {
      position: "absolute",
      top: "12px",
      right: "16px",
      background: "transparent",
      border: "none",
      fontSize: "1.7rem",
      cursor: "pointer",
      color: "#444",
    },
    title: {
      marginBottom: "1.5rem",
      fontSize: "1.5rem",
      fontWeight: 600,
      color: "#2d3748",
    },
    formGroup: {
      marginBottom: "1.2rem",
    },
    label: {
      display: "block",
      marginBottom: "0.4rem",
      fontSize: "0.9rem",
      color: "#4a5568",
      fontWeight: 500,
    },
    input: {
      width: "100%",
      padding: "0.7rem",
      borderRadius: "6px",
      border: "1px solid #cbd5e0",
      fontSize: "1rem",
      outline: "none",
      transition: "0.2s",
    },
    submitBtn: {
      width: "100%",
      padding: "0.9rem",
      background: "#3182ce",
      color: "white",
      border: "none",
      borderRadius: "6px",
      fontWeight: 600,
      cursor: "pointer",
      fontSize: "1rem",
      marginTop: "1.2rem",
    },
  };

  return (
    <div style={styles.backdrop}>
      <div style={styles.modal}>
        <button style={styles.closeBtn} onClick={onClose}>
          ×
        </button>

        <h2 style={styles.title}>Edit Bank Details</h2>

        <div style={styles.formGroup}>
          <label style={styles.label}>Name of the Account Holder</label>
          <input
            style={styles.input}
            type="text"
            name="bank_account_name"
            value={bank.bank_account_name}
            onChange={handleChange}
          />
        </div>

        <div style={styles.formGroup}>
          <label style={styles.label}>Name of the Bank</label>
          <input
            style={styles.input}
            type="text"
            name="bank_name"
            value={bank.bank_name}
            onChange={handleChange}
          />
        </div>

        <div style={styles.formGroup}>
          <label style={styles.label}>Branch</label>
          <input
            style={styles.input}
            type="text"
            name="branch"
            value={bank.branch}
            onChange={handleChange}
          />
        </div>

        <div style={styles.formGroup}>
          <label style={styles.label}>IFSC Code</label>
          <input
            style={styles.input}
            type="text"
            name="ifsc_code"
            value={bank.ifsc_code}
            onChange={handleChange}
          />
        </div>


        <div style={styles.formGroup}>
          <label style={styles.label}>Account Number</label>
          <input
            style={styles.input}
            type="password"
            name="account_number"
            value={bank.account_number}
            onChange={handleChange}
            autoComplete="new-password"
          />
        </div>

        <div style={styles.formGroup}>
          <label style={styles.label}>Re-enter Account Number</label>
          <input
            style={styles.input}
            type="number"
            name="re_account_number"
            value={reAccountNumber}
            onChange={e => setReAccountNumber(e.target.value)}
            autoComplete="new-password"
          />
          {accountNumberError && (
            <div style={{ color: 'red', marginTop: '0.3rem', fontSize: '0.95em' }}>{accountNumberError}</div>
          )}
        </div>

        <button style={styles.submitBtn} onClick={handleSubmit}>
          Update Bank Details
        </button>
      </div>
    </div>
  );
}
